import {
  useCircleSize,
  TouchableBox,
  Box,
  TodoPrioIcon,
  AHText,
  Circle,
  SubjectBreadcrumbs,
  OrgIcon,
} from "arkh";

import React from "react";
import { View } from "react-native";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { AHImageStackNew } from "../RoutineOccasion/TaskExecution/AHImageStack";
import { SignalListItem_signal$key } from "./__generated__/SignalListItem_signal.graphql";
import { UrgentAnimation } from "widgets/src/TodoListItem/UrgentAnimation";

export const SignalListItem = React.memo(SignalListItemC);
function SignalListItemC(props: {
  isFirst?: boolean;
  isLast?: boolean;
  isNew?: boolean;
  signal: SignalListItem_signal$key;
  openSignal(signalId: string): void;
}) {
  const signal = useFragment(
    graphql`
      fragment SignalListItem_signal on Signal {
        id
        priority
        title
        breadcrumbs
        orgIconUri
        descriptionImages {
          ...AHImageStackComponent_Images
        }
      }
    `,
    props.signal
  );

  const smallMedium = useCircleSize("smallMedium");
  const size = useCircleSize("smallMedium");
  return (
    <View>
      {props.isNew ? (
        <View
          style={{
            position: "absolute",
            justifyContent: "center",
            height: "100%",
            left: -12,
            zIndex: 20,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Circle size="dot" color="washedText" />
        </View>
      ) : null}
      <TouchableBox
        color="surface"
        spaceHorizontal="medium"
        style={{
          overflow: "hidden",
          borderRightWidth: 1,
          borderLeftWidth: 1,
          borderBottomWidth: props.isLast ? 1 : 0,
          borderTopWidth: props.isFirst ? 1 : 0,
          marginHorizontal: -1,
          marginBottom: props.isLast ? -1 : 0,
          marginTop: props.isFirst ? -1 : 0,
        }}
        cornerRadiusBottomLeft={props.isLast ? "large" : "none"}
        cornerRadiusBottomRight={props.isLast ? "large" : "none"}
        cornerRadiusTopLeft={props.isFirst ? "large" : "none"}
        cornerRadiusTopRight={props.isFirst ? "large" : "none"}
        borderColor="border-primary"
        onPress={() => props.openSignal(signal.id)}
      >
        <Box spaceBottom="xsmall" spaceTop="small">
          <Box
            style={{
              flexDirection: "row",
              alignItems: "center",
              height: size,
            }}
          >
            <Box
              style={{ flexDirection: "row", alignItems: "center", flex: 1 }}
              spaceRight="xsmall"
            >
              <OrgIcon spaceRight="xsmall" orgIconUri={signal.orgIconUri} />
              <SubjectBreadcrumbs breadcrumbs={signal.breadcrumbs} />
            </Box>
          </Box>
        </Box>
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
            height: smallMedium,
          }}
        >
          {signal.priority !== "DEFAULT" ? (
            <Box spaceRight="small">
              {signal.priority === "URGENT" ? <UrgentAnimation /> : null}
              <TodoPrioIcon priority={signal.priority} hideDefault />
            </Box>
          ) : null}

          <View
            style={{ flex: 1, alignItems: "center", flexDirection: "row" }}
            pointerEvents="none"
          >
            <AHText type="title-small" numberOfLines={1} style={{ flex: 1 }}>
              {signal.title}
            </AHText>
          </View>
          <AHImageStackNew
            images={signal.descriptionImages}
            size={smallMedium}
          />
        </Box>
        <Box spaceTop="small" spaceBottom="small" />
      </TouchableBox>
    </View>
  );
}
